import APIAmplify from '@/amplify/api';
import { onChatPostCreatedForAnonymousUser,onChatPostUpdatedForAnonymous,onChatPostDeletedForAnonymous } from '@/graphql/subscriptions';
import Utils from '@/common/utils/utils';
import Constant from '@/common/constant/Constant';
import { buildTheEndMessage, postMessage, renderMessageOfAgent, updateAgentDataList } from './ChatBoxHandler';

let subscriptionNotificationList = [];

export const connectAnonymousChatThreadSubscription = (chatThreadId, allState) => {
    let chatThreadUUID = chatThreadId.substr(14, 44);
    let subscription = APIAmplify.graphql({
        query: onChatPostCreatedForAnonymousUser,
        variables: { chatThreadId: chatThreadUUID },
        authMode: Constant.AUTH_MODE_API_KEY
    }).subscribe({
        next: resData => {
            let msgRes = resData.value.data.onChatPostCreatedForAnonymousUser;

            if (
                !Utils.isEmptyObject(msgRes) &&
                msgRes.postType === Constant.POST_TYPE.SYSTEM_AUTO_END_LIVE_CHAT
            ){
                if (allState.setIsOpenModalReloadPage) {
                    allState.setIsOpenModalReloadPage(true);
                }
                return;
            } else {
                if (msgRes?.postType === Constant.POST_TYPE.ANONYMOUS_END_LIVE_CHAT) {
                    return;
                };

                // Filter undeliver msg
                if (
                    [
                        Constant.POST_TYPE.MSG,
                        Constant.POST_TYPE.IMAGE,
                        Constant.POST_TYPE.FILE,
                        Constant.POST_TYPE.MSG_FILES
                    ].includes(msgRes?.postType) &&
                    !msgRes?.deliverInfo?.status && 
                    msgRes.affiliationProject
                ) {
                    return;
                }

                const newMessage = renderMessageOfAgent(msgRes, allState.resolvedMessages);
                if (
                    newMessage.messageType ===
                        Constant.DEFAULT_CHATBOT_MESSAGE_TYPE.BACK_TO_BEGIN_AFTER_REJECT ||
                    newMessage.messageType === Constant.DEFAULT_CHATBOT_MESSAGE_TYPE.NOT_FOUND_AGENT ||  newMessage.messageType === Constant.DEFAULT_CHATBOT_MESSAGE_TYPE.END_LIVE_CHAT
                ) {
                    allState.setIsActivateLiveChat(false);
                }

                let agentData = allState.listAgentData?.find(agent => {
                    return agent.id === msgRes.creatorId;
                });
                if (Utils.isEmptyObject(agentData)) {
                    updateAgentDataList(
                        allState.projectId,
                        allState.corporationId,
                        allState.setListAgentData
                    );
                }

                if (
                    newMessage.messageType === Constant.DEFAULT_CHATBOT_MESSAGE_TYPE.END_LIVE_CHAT
                ) {
                    const backToBeginMessage = buildTheEndMessage(1, allState.formQASystems, allState.resolvedMessages);
                    allState.setMessages(pev => [...pev, newMessage, backToBeginMessage]);
                    allState.setIsNewUnReaMessage(true)
                    postMessage(backToBeginMessage, chatThreadId, allState.corporationId);
                } else {
                    allState.setIsNewUnReaMessage(true)
                    allState.setMessages(pev => [...pev, newMessage]);
                }
            }
        },

        error: err => {
            // unsubscription event create
            let isUnsubscribeEventNotification = unsubscribeEventNotification();

            // show alert disconnect
            // if isShowDialog equals true then break
            if (!allState?.isShowReconnectDialog && isUnsubscribeEventNotification === true) {
                allState?.setIsShowReconnectDialog(true);
            }
        }
    });

    return subscription;
};

export const connectAnonymousChatThreadSubscriptionUpdatedMessage = (chatThreadId,allState) => {
    let chatThreadUUID = chatThreadId.substr(14,44)
    let subscription = APIAmplify.graphql({query: onChatPostUpdatedForAnonymous,
        variables: {chatThreadId: chatThreadUUID},
        authMode: Constant.AUTH_MODE_API_KEY,
    }).subscribe({
        next: resData => {
            let msgRes = resData.value.data.onChatPostUpdatedForAnonymous;
            allState.setUpdatedMessage(msgRes)
            // update notification list
        },
        
        error: err => {
            
            // unsubscription event create
            let isUnsubscribeEventNotification = unsubscribeEventNotification();

            // show alert disconnect
            // if isShowDialog equals true then break
            if (!allState?.isShowReconnectDialog && isUnsubscribeEventNotification === true) {
                
                allState?.setIsShowReconnectDialog(true);
            }
        }
    });

    return subscription;
}

export const connectAnonymousChatThreadSubscriptionDeletedMessage = (chatThreadId,allState) => {
    let chatThreadUUID = chatThreadId.substr(14,44)
    let subscription = APIAmplify.graphql({query: onChatPostDeletedForAnonymous,
        variables: {chatThreadId: chatThreadUUID},
        authMode: Constant.AUTH_MODE_API_KEY,
    }).subscribe({
        next: resData => {
            let msgRes = resData.value.data.onChatPostDeletedForAnonymous;
            allState.setDeletedMessages(msgRes);
            // update notification list
        },
        
        error: err => {
            
            // unsubscription event create
            let isUnsubscribeEventNotification = unsubscribeEventNotification();

            // show alert disconnect
            // if isShowDialog equals true then break
            if (!allState?.isShowReconnectDialog && isUnsubscribeEventNotification === true) {
                allState?.setIsShowReconnectDialog(true);
            }
        }
    });

    return subscription;
}

export const unsubscribeEventNotification = () => {
    let isUnsubscribeEventNotification = false;

    if (Utils) {
        return isUnsubscribeEventNotification;
    }

    subscriptionNotificationList.forEach(sub => {
        if (sub.subscription?._state !== 'closed') {
            sub.subscription?.unsubscribe();
            isUnsubscribeEventNotification = true;
        } 
    });

    subscriptionNotificationList = [];
    return isUnsubscribeEventNotification;
};

export const onSubscriptionAnonymousChatThread = (chatThreadId, allState) => {
    const subscription = connectAnonymousChatThreadSubscription(chatThreadId,allState);
    subscriptionNotificationList.push(subscription)
};

export const onSubscriptionAnonymousChatThreadUpdatedMessage = (chatThreadId, allState) => {
    const subscription = connectAnonymousChatThreadSubscriptionUpdatedMessage(chatThreadId,allState);
    subscriptionNotificationList.push(subscription)
};